import amenitiesIcons from "/assets/amenities/amenities-list.json";

export const getAmenityIcon = (amenity) => {
    const iconName = amenitiesIcons[amenity] || "Default-Amenity.png";
    return `/assets/amenities/icons/${iconName}`;
};
